import Vue from "vue";

/**
 * 获取banner图
 */
export function httpPostBanner(){
    return  Vue.$axios({
        url: '/api/game/index/banner',
        method: 'post'
    })
}


/**
 * 获取游戏分类
 * @returns {*}
 */
export function httpPostGameCate(){
    return  Vue.$axios({
        url: '/api/game/index/types',
        method: 'post'
    })
}

/**
 * 获取游戏列表
 */
export function httpPostGameList(data){
    return  Vue.$axios({
        url:"/api/game/index/list",
        method:"post",
        data
    })
}

/**
 * 查询角色余额
 */
export function httpPostRoleBalance(data){
    return  Vue.$axios({
        url:"/api/game/chain_game/balance",
        method:"post",
        data
    })
}

/**
 * 查询服务区信息
 */
export function httpPostServerList(data){
    return  Vue.$axios({
        url:"/api/game/chain_game/serverList",
        method:"post",
        data
    })
}

/**
 * 查询角色信息
 */
export function httpPostRoleList(data){
    return  Vue.$axios({
        url:"/api/game/chain_game/roleList",
        method:"post",
        data
    })
}

/**
 * 绑定游戏角色信息
 */
export function httpPostBindRole(data){
    return  Vue.$axios({
        url:"/api/game/chain_game/bindRole",
        method:"post",
        data
    })
}
